// Short on purpose - see the fail-open comment below.
const FETCH_TIMEOUT_MS = 2000;

const FAIL_OPEN_CONFIG = null; // null = "no override, use the baked REACT_APP_SERVER_* defaults"

export async function fetchMaintenanceConfig() {
  const assetsUrl = process.env.REACT_APP_STATIC_ASSETS_URL;
  if (!assetsUrl) return FAIL_OPEN_CONFIG;

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);
  try {
    // Raw fetch against the assets CDN, not axios (pointed at the API host)
    // and not the app's own origin - this is the same bucket that already
    // serves per-merchant theme CSS (see src/context/AuthContext.js), so it
    // works identically today on Netlify and after any future migration.
    const response = await fetch(`${assetsUrl}/config/maintenance.json`, {
      cache: 'no-store',
      signal: controller.signal,
    });
    if (!response.ok) return FAIL_OPEN_CONFIG;
    const data = await response.json();
    return data && typeof data === 'object' ? data : FAIL_OPEN_CONFIG;
  } catch {
    // Any failure at all - network error, timeout, 404, malformed JSON -
    // fails OPEN. A broken or unreachable maintenance.json must never be
    // able to take the portal down; callers treat `null` exactly like "no
    // override is in effect".
    return FAIL_OPEN_CONFIG;
  } finally {
    clearTimeout(timeout);
  }
}
